import { SET_LANGUAGE, SET_RESTAURANT_ID, SET_RESTAURANT_NAME ,SET_CATEGORIES, SET_ITEMS_BY_CATEGORIES,
         SET_RESTAURANT_INFO, SET_POSTS_FEED, SET_RESTAURANT_NOT_FOUND, SET_CATEGORIES_GRAPH, SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP, SET_DISHES_LOOKUP } from './ActionTypes';

export const setLanguage = ( lang ) => {
    return {
        type: SET_LANGUAGE,
        
        payload: {
            language: lang
        }
    } 
}

export const setRestaurantID = ( newID ) => {
    return {
        type: SET_RESTAURANT_ID,

        payload: {
            restaurant_id: newID,
        }
    }
}

export const setRestaurantName = ( newRestaurantName ) => {
    return {
        type: SET_RESTAURANT_NAME,

        payload: {
            restaurant_name: newRestaurantName,
        }
    }
}

export const setCategories = ( newCategories ) => {
    return {
        type: SET_CATEGORIES,

        payload: {
            categories: newCategories,
        }
    }
}

export const setItemsByCategories = ( items ) => {
    return {
        type: SET_ITEMS_BY_CATEGORIES,

        payload: {
            itemsByCategories: items,
        }
    }
}

export const setRestaurantInfo = ( newInfo ) => {
    return {
        type: SET_RESTAURANT_INFO,

        payload: {
            restaurantInfo: newInfo,
        }
    }
}

export const setPostsFeed = (posts) => {
    return {
        type: SET_POSTS_FEED,

        payload: {
            posts: posts,
        }
    }
}

export const setRestaurantNotFound = ( rnf ) => {
    return {
        type: SET_RESTAURANT_NOT_FOUND,

        payload: {
            restaurantNotFound: rnf,
        }
    }
}

export const setCategoriesGraph = (categoriesGraph) => {
    return {
        type: SET_CATEGORIES_GRAPH,

        payload: {
            categoriesGraph: categoriesGraph,
        }
    }
}

export const setDishesByCategoryGraphLookup = (graphsLookup) => {
    return {
        type: SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP,

        payload: {
            dishesByCategoriesGraphLookup: graphsLookup,
        }
    }
}

export const setDishesLookup = (dishesLookupTable) => {
    return {
        type: SET_DISHES_LOOKUP,

        payload: {
            dishesLookup: dishesLookupTable
        }
    }
}